const menuToggle = document.querySelector(".menu-toggle");
const primaryNav = document.querySelector(".primary-nav");

if (menuToggle && primaryNav) {
  menuToggle.addEventListener("click", () => {
    const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
    menuToggle.setAttribute("aria-expanded", String(!isOpen));
    menuToggle.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
    menuToggle.classList.toggle("is-open", !isOpen);
    primaryNav.classList.toggle("is-open", !isOpen);
  });
}

document.querySelectorAll(".filter-chip").forEach((chip) => {
  chip.addEventListener("click", () => {
    document.querySelectorAll(".filter-chip").forEach((item) => item.classList.remove("active"));
    chip.classList.add("active");
  });
});

const proofIconSource = document.querySelector(".hero-proof-icon-source")?.dataset.icon;

if (proofIconSource) {
  document.querySelectorAll(".hero-proof span").forEach((item) => {
    if (item.querySelector("img")) return;
    const icon = document.createElement("img");
    icon.src = proofIconSource;
    icon.alt = "";
    icon.setAttribute("aria-hidden", "true");
    item.textContent = item.textContent.replace(/^[◷♢▱]\s*/, "");
    item.prepend(icon);
  });
}

document.querySelectorAll(".quantity-control button").forEach((button) => {
  if (button.hasAttribute("data-step")) return;
  button.addEventListener("click", () => {
    const input = button.parentElement.querySelector("input");
    const step = Number(button.dataset.step || 0);
    const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
    input.value = nextValue;
  });
});

document.querySelectorAll(".soe-cart-quantity-button").forEach((button) => {
  button.addEventListener("click", async () => {
    if (button.dataset.cartUpdating === "true") return;
    const control = button.closest(".soe-cart-quantity-control");
    const input = control?.querySelector("[data-cart-quantity-input]");
    if (!input) return;
    const step = Number(button.dataset.cartQuantityStep || 0);
    const nextValue = Math.max(Number(input.min || 0), Number(input.value || 0) + step);
    input.value = nextValue;
    await updateCartLine(input.dataset.line, nextValue, button);
  });
});

document.querySelectorAll("[data-cart-quantity-input]").forEach((input) => {
  input.addEventListener("change", () => {
    const nextValue = Math.max(Number(input.min || 0), Number(input.value || 0));
    input.value = nextValue;
    updateCartLine(input.dataset.line, nextValue, input);
  });
});

document.querySelectorAll("[data-open-chat]").forEach((button) => {
  button.addEventListener("click", () => {
    const chat = document.querySelector("shopify-chat");
    if (chat && typeof chat.open === "function") { chat.open(); return; }
    if (window.ShopifyChat && typeof window.ShopifyChat.open === "function") { window.ShopifyChat.open(); }
  });
});

document.querySelectorAll("[data-cart-remove]").forEach((link) => {
  link.addEventListener("click", async (event) => {
    if (!window.fetch) return;
    event.preventDefault();
    await updateCartLine(link.dataset.line, 0, link);
  });
});

async function updateCartLine(line, quantity, trigger) {
  if (!line || trigger?.dataset.cartUpdating === "true") return;
  trigger.dataset.cartUpdating = "true";
  trigger.setAttribute("aria-busy", "true");
  if (trigger instanceof HTMLButtonElement) trigger.disabled = true;
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error("Unable to update cart");
    window.location.reload();
  } catch (error) {
    trigger.dataset.cartUpdating = "false";
    trigger.removeAttribute("aria-busy");
    window.location.assign("/cart");
  }
}

document.querySelectorAll("[data-blend-builder]").forEach((builder) => {
  const fields = [...builder.querySelectorAll(".blend-scent-select")];
  const counter = builder.querySelector("[data-blend-count]");
  const summary = builder.querySelector("[data-blend-summary]");
  const status = builder.querySelector("[data-blend-status]");
  const form = builder.closest("form");
  const submit = form?.querySelector("[data-blend-submit]");
  const baseSubmitDisabled = submit?.dataset.baseDisabled === "true";
  const requestInput = form?.querySelector("[data-blend-request]");
  const bottleInput = form?.querySelector("[data-blend-bottle]");
  const totalInput = form?.querySelector("[data-blend-total]");
  const datalist = document.getElementById(fields[0]?.getAttribute("list"));
  const scentOptions = datalist?.options || fields[0]?.options || [];
  const validScents = new Set([...scentOptions].map((option) => option.value.toLowerCase()).filter(Boolean));
  builder._validScents = validScents;
  const portions = { "1/8": 3, "1/4": 6, "1/3": 8, "3/8": 9, "1/2": 12 };
  let lastAmountChanged = null;
  const fraction = (value) => {
    if (value === 24) return "1 whole bottle";
    const divisor = [24, 12, 8, 6, 4, 3, 2, 1].find((item) => value % item === 0) || 1;
    return `${value / divisor}/${24 / divisor}`;
  };

  // Each row has one fragrance selector and one proportion selector. A filled
  // selector swaps its dropdown arrow for a clear control.
  fields.forEach((field) => {
    const controls = field.closest(".blend-field")?.querySelector(".blend-field-controls");
    const amount = controls?.querySelector("[data-blend-amount]");
    if (!controls || !amount) return;
    controls.querySelectorAll("[data-blend-clear]").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.dataset.blendClear === "family") {
          const family = field.closest(".blend-field")?.querySelector(".blend-family-select");
          if (family) {
            family.value = "";
            family.focus();
          }
        } else if (button.dataset.blendClear === "scent") {
          field.value = "";
          amount.value = "";
          field.focus();
        } else {
          amount.value = "";
          amount.focus();
        }
        updateBlend();
      });
    });
  });

  const updateBlend = () => {
    const readEntries = () => fields.map((field) => ({
      field,
      scent: field.value.trim(),
      amount: field.closest(".blend-field")?.querySelector("[data-blend-amount]")?.value || ""
    })).filter((entry) => entry.scent || entry.amount);
    let entries = readEntries();
    let total = entries.reduce((sum, entry) => sum + (portions[entry.amount] || 0), 0);
    let clearedOverLimitAmount = false;

    // Do not leave the customer on an impossible blend. Only the amount they
    // just chose is cleared; no scent or valid proportion is changed for them.
    if (total > 24 && lastAmountChanged) {
      lastAmountChanged.value = "";
      entries = readEntries();
      total = entries.reduce((sum, entry) => sum + (portions[entry.amount] || 0), 0);
      clearedOverLimitAmount = true;
    }

    const scents = entries.map((entry) => entry.scent.toLowerCase());
    const hasInvalidScent = entries.some((entry) => entry.scent && !validScents.has(entry.scent.toLowerCase()));
    const hasIncompleteEntry = entries.some((entry) => !entry.scent || !entry.amount);
    const hasDuplicate = new Set(scents).size !== scents.length;
    const isCustomBlend = entries.length > 0;
    const blendName = form?.querySelector('[name="properties[Blend name]"]')?.value.trim() || "";
    const selectedVariant = form?.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
    const bottleName = selectedVariant?.dataset.bottleName || "";
    const bottlePrice = selectedVariant?.dataset.price || "";
    const bottleConfirmed = Boolean(selectedVariant?.value);

    if (counter) counter.textContent = `${entries.filter((entry) => entry.scent).length} of 4 scents selected`;
    if (summary) {
      summary.innerHTML = "";
      entries.forEach((entry) => {
        if (!entry.scent) return;
        const item = document.createElement("li");
        item.textContent = entry.amount ? `${entry.scent} · ${entry.amount}` : entry.scent;
        summary.append(item);
      });
    }
    fields.forEach((field) => {
      const amount = field.closest(".blend-field")?.querySelector("[data-blend-amount]");
      const scent = field.value.trim().toLowerCase();
      const isDuplicate = Boolean(scent) && scents.filter((value) => value === scent).length > 1;
      field.closest(".blend-field")?.classList.toggle("has-duplicate", isDuplicate);
      if (amount) amount.disabled = !field.value.trim();
      if (amount) {
        const otherTotal = entries.reduce((sum, entry) => entry.field === field ? sum : sum + (portions[entry.amount] || 0), 0);
        [...amount.options].forEach((option) => {
          option.disabled = !field.value.trim() || Boolean(option.value && otherTotal + (portions[option.value] || 0) > 24);
        });
      }
      field.setCustomValidity(field.value.trim() && !validScents.has(field.value.trim().toLowerCase()) ? "Choose a fragrance oil from the list." : "");
      const family = field.closest(".blend-field")?.querySelector(".blend-family-select");
      family?.closest(".blend-family-menu")?.classList.toggle("has-selection", Boolean(family?.value));
      field.closest(".blend-scent-menu")?.classList.toggle("has-selection", Boolean(field.value.trim()));
      amount?.closest(".blend-amount-menu")?.classList.toggle("has-selection", Boolean(amount?.value) && !amount.disabled);
    });

    // A fragrance can only occupy one part of the blend.
    fields.forEach((field) => {
      if (field.tagName !== "SELECT") return;
      const currentValue = field.value.trim().toLowerCase();
      [...field.options].forEach((option) => {
        const isUsedElsewhere = option.value && option.value.toLowerCase() !== currentValue && scents.includes(option.value.toLowerCase());
        option.disabled = isUsedElsewhere;
      });
    });

    const selectedFormat = form?.querySelector("[data-blend-selected-format]");
    if (selectedFormat) selectedFormat.textContent = bottleConfirmed ? `Selected bottle size: ${bottleName}${bottlePrice ? ` · ${bottlePrice}` : ""}` : "Select a bottle size to start a custom blend.";

    let message = "Select a bottle size, then add fragrance oils and proportions.";
    const ready = isCustomBlend && bottleConfirmed && !hasInvalidScent && !hasIncompleteEntry && !hasDuplicate && total > 0 && total <= 24;
    const canSubmit = builder.dataset.requireBlend === "true" ? ready : (!isCustomBlend && !blendName || ready);
    if (!bottleConfirmed) message = "Choose a bottle size before creating a custom blend.";
    else if (!isCustomBlend) message = "Add a fragrance oil and its proportion to create your custom blend.";
    else if (hasInvalidScent) message = "Choose fragrance oils from the suggested list or browse the available oils.";
    else if (hasDuplicate) message = `Each fragrance oil can be selected only once.${total < 24 ? ` Choose different oils, then complete the remaining ${fraction(24 - total)}.` : " Choose different oils to continue."}`;
    else if (clearedOverLimitAmount) message = "That proportion would exceed one whole bottle, so it was cleared. Choose one of the available amounts.";
    else if (hasIncompleteEntry) message = "Choose a proportion for every fragrance oil in your blend.";
    else if (total > 24) message = `Blend total: ${fraction(total)}. Your blend is over one whole bottle.`;
    else if (total < 24) message = `Blend total: ${fraction(total)}. Your custom blend is ready.`;
    else message = "Blend total: 1 whole bottle. Your custom blend is ready.";
    if (status) status.textContent = message;
    if (requestInput) requestInput.disabled = !ready;
    if (bottleInput) { bottleInput.disabled = !isCustomBlend || !bottleName; bottleInput.value = bottleName; }
    if (totalInput) { totalInput.disabled = !ready; totalInput.value = ready ? (total === 24 ? "1 whole bottle" : `${fraction(total)} of one bottle`) : ""; }
    if (submit) submit.disabled = baseSubmitDisabled || !canSubmit;
  };

  fields.forEach((field) => {
    field.addEventListener("input", updateBlend);
    field.addEventListener("change", updateBlend);
  });
  // Scent-family dropdown narrows that row's fragrance list to matching oils.
  const BLEND_FAMILY_KEYWORDS = {
    vanilla: ["vanilla"],
    sweet: ["sweet", "caramel", "honey", "sugar", "praline", "gourmand"],
    floral: ["floral", "jasmine", "peony", "gardenia", "blossom"],
    rose: ["rose"],
    fruity: ["fruit", "berry", "peach", "pear", "apple", "cherry", "tropical", "mango"],
    "fresh & clean": ["fresh", "clean", "linen", "aquatic", "marine"],
    citrus: ["citrus", "lemon", "orange", "bergamot", "lime"],
    musk: ["musk"],
    "powdery & soft": ["powder", "soft"],
    "amber & warm": ["amber", "warm"],
    woody: ["wood", "sandalwood", "cedar", "patchouli", "vetiver"],
    spicy: ["spice", "cinnamon", "clove", "cardamom", "saffron", "pepper"],
    oud: ["oud"]
  };
  builder.querySelectorAll(".blend-family-select").forEach((family) => {
    const scentSelect = family.closest(".blend-field")?.querySelector(".blend-scent-select");
    if (scentSelect && !scentSelect.dataset.masterOptions) scentSelect.dataset.masterOptions = "1";
    if (scentSelect) scentSelect._allOptions = [...scentSelect.options].map((option) => ({ value: option.value, text: option.textContent }));
    family.addEventListener("change", () => {
      if (!scentSelect?._allOptions) return;
      const terms = BLEND_FAMILY_KEYWORDS[(family.value || "").toLowerCase()] || [];
      const currentValue = scentSelect.value;
      scentSelect.innerHTML = "";
      scentSelect._allOptions.forEach(({ value, text }) => {
        const matches = !terms.length || (value && terms.some((term) => text.toLowerCase().includes(term)));
        if (!value || matches) scentSelect.append(new Option(text, value));
      });
      if ([...scentSelect.options].some((option) => option.value === currentValue)) scentSelect.value = currentValue;
      else scentSelect.value = "";
      updateBlend();
    });
  });
  builder.querySelectorAll("[data-blend-amount]").forEach((amount) => amount.addEventListener("change", () => {
    lastAmountChanged = amount;
    updateBlend();
    lastAmountChanged = null;
  }));
  form?.addEventListener("change", (event) => {
    if (event.target.matches('input[name="id"]')) updateBlend();
  });
  form?.querySelector('[name="properties[Blend name]"]')?.addEventListener("input", updateBlend);
  updateBlend();
});

const mainProductImage = document.querySelector(".main-product-image");

document.querySelectorAll(".thumb").forEach((button) => {
  button.addEventListener("click", () => {
    if (!mainProductImage || !button.dataset.image) return;
    mainProductImage.src = button.dataset.image;
    mainProductImage.alt = button.querySelector("img")?.alt || mainProductImage.alt;
    document.querySelectorAll(".thumb").forEach((item) => {
      item.classList.remove("is-active");
      item.setAttribute("aria-pressed", "false");
    });
    button.classList.add("is-active");
    button.setAttribute("aria-pressed", "true");
  });
});

document.addEventListener("change", (event) => {
  const card = event.target.closest?.(".variant-card");
  if (!card) return;
  card.closest("fieldset")?.querySelectorAll(".variant-card").forEach((item) => item.classList.remove("is-selected"));
  card.classList.add("is-selected");
  if (mainProductImage && card.dataset.image) {
    mainProductImage.src = card.dataset.image;
  }
  const price = card.closest("form")?.querySelector(".pdp-price") || document.querySelector(".pdp-price");
  if (price && card.dataset.price) {
    price.textContent = card.dataset.price;
  }
  const addButton = card.closest("form")?.querySelector("[data-blend-submit]");
  if (addButton && card.dataset.price && addButton.dataset.baseDisabled !== "true") {
    addButton.textContent = `Add to Cart - ${card.dataset.price}`;
  }
});

// Keep the submit button price in sync with the chosen variant x quantity.
const priceButtonTemplate = (form) => (form?.dataset.moneyFormat || "${{amount}}").replace(/\{\{\s*amount[^}]*\}\}/g, "__AMOUNT__");

const syncPricedButton = (form) => {
  const button = form?.querySelector("[data-blend-submit]");
  if (!button || button.dataset.baseDisabled === "true") return;
  const selected = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
  const unitCents = Number(selected?.dataset.priceCents || 0);
  if (!unitCents) return;
  const quantity = Math.max(1, parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1);
  if (!button.dataset.priceLabel) button.dataset.priceLabel = button.textContent.split(" - ")[0] || "Add to Cart";
  button.textContent = `${button.dataset.priceLabel} - ${priceButtonTemplate(form).replace("__AMOUNT__", ((unitCents * quantity) / 100).toFixed(2))}`;
};

["change", "input"].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    const form = event.target.closest?.(".custom-blend-form");
    if (form && event.target.matches('input[name="id"], input[name="quantity"]')) syncPricedButton(form);
  });
});

document.querySelectorAll(".custom-blend-form").forEach(syncPricedButton);

document.querySelectorAll(".quantity-control [data-step]").forEach((button) => {
  button.addEventListener("click", () => {
    const input = button.closest(".quantity-control")?.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 1;
    const next = Math.max(1, current + Number(button.dataset.step || 0));
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
});

document.querySelectorAll(".collection-quick-add button").forEach((button) => {
  const label = button.querySelector("span:first-child");
  if (label && !button.disabled) {
    label.textContent = "Add to cart";
    button.querySelectorAll("span:nth-child(2), span:nth-child(3)").forEach((item) => item.remove());
  }
});

document.querySelectorAll(".collection-quick-add, .purchase-box").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = "Adding...";
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error("Unable to add item");

      if (button) button.textContent = "Added";

      const cartResponse = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      const cart = cartResponse.ok ? await cartResponse.json() : null;
      const cartLink = document.querySelector('.header-actions a[href="/cart"], .header-actions a[href$="/cart"]');
      if (cart && cartLink) {
        cartLink.textContent = `Cart${cart.item_count > 0 ? ` (${cart.item_count})` : ""}`;
      }

      window.location.assign("/cart");
    } catch (error) {
      form.submit();
    }
  });
});

document.querySelectorAll("[data-blend-product-picker]").forEach((picker) => {
  const filter = picker.querySelector("[data-product-filter]");
  const status = picker.querySelector("[data-product-status]");
  const count = picker.querySelector("[data-product-count]");
  const pills = [...picker.querySelectorAll("[data-family-filter]")];
  const cards = [...picker.querySelectorAll(".blend-product-card")];
  const step = picker.closest("[data-blend-product-step]");
  const chosen = step?.querySelector("[data-product-chosen]");
  const chosenName = step?.querySelector("[data-product-chosen-name]");
  const changeButton = step?.querySelector("[data-product-change]");
  const form = document.querySelector("[data-blend-page-form]");
  const formatCards = form?.querySelector("[data-format-cards]");
  const priceEl = form?.querySelector("[data-blend-price]");
  const moneyFormat = (form?.dataset.moneyFormat || "${{amount}}").replace(/\{\{\s*amount[^}]*\}\}/g, "__AMOUNT__");
  const money = (cents) => moneyFormat.replace("__AMOUNT__", (cents / 100).toFixed(2));
  const isWholesale = (title) => /16oz|16ounce|32oz|32ounce/.test(title.toLowerCase().replace(/\s+/g, ""));
  let activeTerms = [];

  const grid = picker.querySelector("[data-product-grid]");
  const applyFilters = () => {
    const query = (filter?.value || "").trim().toLowerCase();
    let visible = 0;
    cards.forEach((card) => {
      const name = card.dataset.productName || "";
      const matchesQuery = !query || name.includes(query);
      const matchesFamily = !activeTerms.length || activeTerms.some((term) => name.includes(term));
      card.hidden = !(matchesQuery && matchesFamily);
      if (!card.hidden) visible += 1;
    });
    if (count) count.textContent = visible === cards.length ? `${visible} fragrance oils` : `${visible} of ${cards.length} fragrance oils`;
  };
  applyFilters();

  filter?.addEventListener("input", applyFilters);

  pills.forEach((pill) => {
    pill.addEventListener("click", () => {
      pills.forEach((item) => { item.classList.remove("is-active"); item.setAttribute("aria-pressed", "false"); });
      pill.classList.add("is-active");
      pill.setAttribute("aria-pressed", "true");
      activeTerms = (pill.dataset.familyFilter || "").split(",").filter(Boolean);
      applyFilters();
    });
  });

  const renderVariants = (product) => {
    let variants = product.variants.filter((variant) => !isWholesale(variant.title) && !/32\s*oz/i.test(variant.title));
    if (!variants.length) variants = product.variants;
    formatCards.querySelectorAll(".variant-card").forEach((card) => card.remove());
    variants.forEach((variant, index) => {
      const card = document.createElement("label");
      const image = variant.featured_image?.src || product.featured_image;
      card.className = `variant-card${index === 0 ? " is-selected" : ""}${image ? "" : " variant-card--text"}`;
      card.dataset.price = money(variant.price);
      const input = document.createElement("input");
      input.type = "radio";
      input.name = "id";
      input.value = variant.id;
      input.dataset.bottleName = variant.title;
      input.dataset.price = money(variant.price);
      input.dataset.priceCents = variant.price;
      if (index === 0) input.checked = true;
      if (!variant.available) input.disabled = true;
      card.append(input);
      if (image) {
        const img = document.createElement("img");
        img.src = image;
        img.alt = variant.title;
        img.width = 1000;
        img.height = 1000;
        card.append(img);
      }
      const text = document.createElement("span");
      const name = document.createElement("strong");
      name.textContent = variant.title;
      const price = document.createElement("small");
      price.textContent = money(variant.price);
      text.append(name, price);
      card.append(text);
      formatCards.append(card);
    });
    const first = variants[0];
    if (priceEl && first) priceEl.textContent = money(first.price);
    formatCards.querySelector('input[name="id"]:checked')?.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const chooseProduct = async (handle, title) => {
    if (!handle || !form || !formatCards) return;
    picker.setAttribute("aria-busy", "true");
    if (status) status.textContent = "Loading bottle sizes…";
    try {
      const response = await fetch(`/products/${handle}.js`, { headers: { "Accept": "application/json" } });
      if (!response.ok) throw new Error("Unable to load product");
      const product = await response.json();
      renderVariants(product);
      if (chosenName) chosenName.textContent = product.title;
      if (chosen) chosen.hidden = false;
      picker.hidden = true;
      form.hidden = false;
      if (status) status.textContent = "";
      form.scrollIntoView({ block: "start", behavior: "smooth" });
    } catch (error) {
      if (status) status.textContent = "Could not load that fragrance. Please try again.";
    } finally {
      picker.removeAttribute("aria-busy");
    }
  };

  grid?.addEventListener("click", (event) => {
    const card = event.target.closest(".blend-product-card");
    if (card) chooseProduct(card.dataset.productHandle, card.dataset.productName);
  });

  // Sections cap collection loops at 50 products — load the full oil catalog client-side.
  const BLEND_TITLE_EXCLUDE = /(^|\s)incense|(^|\s)resin|wax|soap|burner|warmer|lamp|lotion|butter|bead|candle|diffuser|stick|wash/i;
  const isEligibleOil = (product) => {
    const type = (product.product_type || "").toLowerCase();
    if (type && !/fragrance|perfume|cologne|body oil/.test(type)) return false;
    return !BLEND_TITLE_EXCLUDE.test(product.title || "");
  };
  (async () => {
    try {
      const products = [];
      for (let page = 1; page <= 4; page += 1) {
        const response = await fetch(`/products.json?limit=250&page=${page}`, { headers: { Accept: "application/json" } });
        if (!response.ok) break;
        const batch = (await response.json()).products || [];
        products.push(...batch);
        if (batch.length < 250) break;
      }
      const seen = new Set(cards.map((card) => card.dataset.productHandle));
      const scentSelects = [...document.querySelectorAll(".blend-scent-select")];
      const seenScents = new Set(scentSelects[0] ? [...scentSelects[0].options].map((o) => o.value.toLowerCase()).filter(Boolean) : []);
      products.forEach((product) => {
        if (!isEligibleOil(product)) return;
        if (!seen.has(product.handle)) {
          seen.add(product.handle);
          const card = document.createElement("button");
          card.type = "button";
          card.className = "blend-product-card";
          card.dataset.productHandle = product.handle;
          card.dataset.productName = (product.title || "").toLowerCase();
          const retail = product.variants?.find((variant) => !isWholesale(variant.title) && !/32\s*oz/i.test(variant.title)) || product.variants?.[0];
          const image = product.images?.[0]?.src;
          const fallbackImage = picker.dataset.fallbackImage || "";
          card.innerHTML = `<img width="400" height="400" loading="lazy" src="${image ? `${image}${image.includes("?") ? "&" : "?"}width=400` : fallbackImage}" alt="${(product.title || "").replace(/"/g, "&quot;")}"><span class="blend-product-card-name">${product.title || ""}</span><span class="blend-product-card-price">${retail ? money(retail.price) : ""}</span>`;
          grid?.append(card);
          cards.push(card);
        }
        if (!seenScents.has((product.title || "").toLowerCase())) {
          seenScents.add(product.title.toLowerCase());
          scentSelects.forEach((select) => select.append(new Option(product.title, product.title)));
          document.querySelectorAll("[data-blend-builder]").forEach((b) => b._validScents?.add(product.title.toLowerCase()));
        }
      });
      scentSelects.forEach((select) => { select._allOptions = [...select.options].map((option) => ({ value: option.value, text: option.textContent })); });
      applyFilters();
    } catch (error) { /* fall back to the server-rendered list */ }
  })();

  changeButton?.addEventListener("click", () => {
    formatCards?.querySelectorAll(".variant-card").forEach((card) => card.remove());
    if (form) form.hidden = true;
    if (chosen) chosen.hidden = true;
    picker.hidden = false;
    filter?.focus();
  });

  const preset = new URLSearchParams(window.location.search).get("product");
  if (preset) chooseProduct(preset);
});

document.querySelectorAll("[data-fragrance-search]").forEach((form) => {
  const input = form.querySelector("[data-fragrance-search-input]");
  const suggestions = form.querySelector("[data-fragrance-suggestions]");
  const clearButton = form.querySelector("[data-search-clear]");
  const syncClear = () => { if (clearButton) clearButton.hidden = !input?.value.trim(); };
  syncClear();
  clearButton?.addEventListener("click", () => {
    if (!input) return;
    input.value = "";
    if (suggestions) suggestions.hidden = true;
    syncClear();
    input.focus();
  });
  let request;
  let timer;
  const isWearableOil = (product) => {
    const title = (product.title || "").toLowerCase();
    const type = (product.type || "").toLowerCase();
    if (title.includes("wax")) return false;
    if (type) return /fragrance|perfume|cologne|body oil/.test(type);
    return !/soap|burner|warmer|candle|lamp|tealight|charcoal|smudge|chew|(^|\s)incense|(^|\s)resin/.test(title);
  };
  const render = (products) => {
    if (!suggestions) return;
    suggestions.innerHTML = "";
    products.slice(0, 6).forEach((product) => {
      const link = document.createElement("a");
      link.href = product.url;
      link.textContent = product.title;
      suggestions.append(link);
    });
    suggestions.hidden = products.length === 0;
  };
  input?.addEventListener("input", () => {
    const query = input.value.trim();
    syncClear();
    window.clearTimeout(timer);
    if (query.length < 2) { if (suggestions) suggestions.hidden = true; return; }
    timer = window.setTimeout(async () => {
      request?.abort();
      request = new AbortController();
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`, { signal: request.signal });
        if (!response.ok) return;
        const json = await response.json();
        render((json.resources?.results?.products || []).filter(isWearableOil));
      } catch (error) {
        if (error.name !== "AbortError" && suggestions) suggestions.hidden = true;
      }
    }, 180);
  });
});

document.querySelectorAll("[data-open-chat]").forEach((button) => {
  button.addEventListener("click", () => {
    const chat = document.querySelector('[aria-label="Chat"], [title="Chat"], .shopify-chat-button');
    if (chat instanceof HTMLElement) chat.click();
  });
});

document.querySelectorAll("[data-shop-all-filters]").forEach((form) => {
  const grid = document.querySelector("[data-shop-all-grid]");
  const count = document.querySelector("[data-shop-all-count]");
  const pagination = grid?.closest(".collection-grid-section")?.querySelector(".collection-pagination");
  const search = form.querySelector('[name="q"]');
  const collectionSelect = form.querySelector("[data-collection-select]");
  const typeSelect = form.querySelector('[name="filter.p.product_type"]');
  const availabilitySelect = form.querySelector('[name="filter.v.availability"]');
  const submit = form.querySelector('button[type="submit"]');
  const status = form.parentElement?.querySelector("[data-shop-all-filter-status]");
  const productCache = new Map();
  let searchTimer;
  const nonOilTitle = /wax|soap|burner|warmer|candle|lamp|tealight|charcoal|smudge|chew|(^|\s)incense|(^|\s)resin/;
  const isPerfumeOil = (product) => {
    const type = (product.product_type || "").toLowerCase();
    if (type) return /fragrance|perfume|cologne|body oil/.test(type);
    return !nonOilTitle.test((product.title || "").toLowerCase());
  };

  const escapeHtml = (value) => String(value || "").replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
  const productIsAvailable = (product) => product.available ?? product.variants?.some((variant) => variant.available);
  const money = (value) => `$${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const syncSelect = (select) => {
    const wrapper = select.closest(".filter-select");
    if (wrapper) wrapper.classList.toggle("has-value", Boolean(select.value));
  };

  const syncSearch = () => {
    search?.closest(".filter-search")?.classList.toggle("has-value", Boolean(search.value.trim()));
  };

  const filterSummary = () => {
    const filters = [];
    if (search?.value.trim()) filters.push(`Search: “${search.value.trim()}”`);
    if (collectionSelect?.selectedOptions[0]?.value) filters.push(`Collection: ${collectionSelect.selectedOptions[0].textContent}`);
    if (typeSelect?.selectedOptions[0]?.value) filters.push(`Product type: ${typeSelect.selectedOptions[0].textContent}`);
    if (availabilitySelect?.selectedOptions[0]?.value) filters.push(`Availability: ${availabilitySelect.selectedOptions[0].textContent}`);
    return filters;
  };

  const setStatus = (message) => {
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || "";
  };

  form.querySelectorAll("select").forEach((select) => {
    syncSelect(select);
    select.addEventListener("change", () => {
      syncSelect(select);
      form.requestSubmit();
    });
  });

  syncSearch();
  search?.addEventListener("input", () => {
    syncSearch();
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(() => form.requestSubmit(), 320);
  });

  form.querySelectorAll("[data-clear-search]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!search) return;
      search.value = "";
      syncSearch();
      form.requestSubmit();
    });
  });

  form.querySelectorAll("[data-clear-filter]").forEach((button) => {
    button.addEventListener("click", () => {
      const select = button.closest(".filter-select")?.querySelector("select");
      if (!select) return;
      select.selectedIndex = 0;
      syncSelect(select);
      form.requestSubmit();
    });
  });

  const fetchProducts = async (sourceUrl) => {
    const normalizedUrl = sourceUrl.replace(/\/$/, "");
    if (!productCache.has(normalizedUrl)) {
      productCache.set(normalizedUrl, (async () => {
        const products = [];
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(`${normalizedUrl}/products.json?limit=250&page=${page}`, { headers: { Accept: "application/json" } });
          if (!response.ok) throw new Error("Unable to load products");
          const payload = await response.json();
          const batch = payload.products || [];
          products.push(...batch);
          if (batch.length < 250) break;
        }
        return products;
      })());
    }
    return productCache.get(normalizedUrl);
  };

  const addDynamicCartHandler = (cartForm) => {
    cartForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = cartForm.querySelector("button");
      if (button) { button.disabled = true; button.textContent = "Adding..."; }
      try {
        const response = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(cartForm) });
        if (!response.ok) throw new Error("Unable to add item");
        window.location.assign("/cart");
      } catch (error) {
        cartForm.submit();
      }
    });
  };

  const renderProducts = (products) => {
    if (!grid) return;
    const visibleProducts = products.slice(0, 48);
    grid.innerHTML = "";
    if (!visibleProducts.length) {
      grid.innerHTML = '<p class="collection-empty">No products match these filters.</p>';
      if (count) count.textContent = "0 products";
      if (pagination) pagination.hidden = true;
      return;
    }
    const fragment = document.createDocumentFragment();
    visibleProducts.forEach((product) => {
      const available = productIsAvailable(product);
      const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
      const image = product.images?.[0]?.src || product.image?.src || "";
      const description = String(product.body_html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim().slice(0, 110);
      const card = document.createElement("article");
      card.className = `collection-product-card${available ? "" : " is-sold-out"}`;
      const badgeType = isPerfumeOil(product) ? "Perfume Oils" : (product.product_type || "Fragrance oil");
      const variantPrices = (product.variants || []).map((item) => Number(item.price) || 0);
      const minVariantPrice = variantPrices.length ? Math.min(...variantPrices) : 0;
      const maxVariantPrice = variantPrices.length ? Math.max(...variantPrices) : 0;
      const priceLabel = minVariantPrice === maxVariantPrice ? money(minVariantPrice) : `${money(minVariantPrice)} – ${money(maxVariantPrice)}`;
      card.innerHTML = `<a class="collection-product-image" href="/products/${encodeURIComponent(product.handle)}"><span class="product-badge">${escapeHtml(badgeType)}</span>${image ? `<img width="1000" height="1000" loading="lazy" src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}">` : ""}</a><div class="collection-product-copy"><h3><a href="/products/${encodeURIComponent(product.handle)}">${escapeHtml(product.title)}</a></h3><p>${escapeHtml(description)}</p><div class="collection-product-buy"><span>${priceLabel}</span></div><form method="post" action="/cart/add" class="collection-quick-add"><input type="hidden" name="id" value="${escapeHtml(variant?.id)}"><button type="submit"${available && variant ? "" : " disabled"}>${available && variant ? "Add to cart" : "Unavailable"}</button></form></div>`;
      const cartForm = card.querySelector("form");
      if (cartForm && available && variant) addDynamicCartHandler(cartForm);
      fragment.append(card);
    });
    grid.append(fragment);
    if (count) count.textContent = `${products.length} product${products.length === 1 ? "" : "s"}`;
    if (pagination) pagination.hidden = true;
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!grid) return;
    const query = search?.value.trim().toLowerCase() || "";
    const selectedCollectionUrl = collectionSelect?.value || "";
    const selectedType = typeSelect?.value || "";
    const selectedAvailability = availabilitySelect?.value || "";
    const hasFilter = Boolean(query || selectedCollectionUrl || selectedType || selectedAvailability);
    if (!hasFilter) {
      setStatus("");
      window.location.assign(form.action);
      return;
    }
    const originalText = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = "Filtering..."; }
    grid.setAttribute("aria-busy", "true");
    try {
      const source = selectedCollectionUrl || form.dataset.productsUrl;
      const products = await fetchProducts(source);
      const matches = products.filter((product) => {
        const searchable = `${product.title || ""} ${product.product_type || ""} ${product.tags || ""}`.toLowerCase();
        const matchesQuery = !query || searchable.includes(query);
        const matchesType = !selectedType || (selectedType === "__perfume_oils" ? isPerfumeOil(product) : product.product_type === selectedType);
        const available = productIsAvailable(product);
        const matchesAvailability = !selectedAvailability || (selectedAvailability === "1" ? available : !available);
        const isDiscontinued = (product.title || "").toLowerCase().includes("wax");
        return matchesQuery && matchesType && matchesAvailability && !isDiscontinued;
      });
      renderProducts(matches);
      const summary = filterSummary();
      setStatus(`Showing ${matches.length} product${matches.length === 1 ? "" : "s"} for ${summary.join(" · ")}.`);
    } catch (error) {
      if (grid) grid.innerHTML = '<p class="collection-empty">We could not filter products right now. Please try again.</p>';
      setStatus("We could not apply those filters right now. Please try again.");
    } finally {
      grid.removeAttribute("aria-busy");
      if (submit) { submit.disabled = false; submit.textContent = originalText; }
    }
  });
});






// Homepage carousels — touch swipe + auto-advance
document.querySelectorAll("[data-soe-carousel]").forEach((track) => {
  const wrap = document.createElement("div");
  wrap.className = "soe-carousel-wrap";
  track.parentNode.insertBefore(wrap, track);
  wrap.appendChild(track);

  const makeArrow = (dir) => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = `soe-carousel-arrow soe-carousel-${dir}`;
    button.setAttribute("aria-label", dir === "prev" ? "Scroll back" : "Scroll forward");
    button.innerHTML = dir === "prev" ? "&#8249;" : "&#8250;";
    return button;
  };
  const prev = makeArrow("prev");
  const next = makeArrow("next");
  wrap.append(prev, next);

  const step = () => {
    const item = track.children[0];
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
  };
  const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
  const goNext = () => {
    if (atEnd()) {
      track.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      track.scrollBy({ left: step(), behavior: "smooth" });
    }
  };

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  let timer = null;
  let resume = null;
  const start = () => {
    if (!timer && !reduced.matches) timer = setInterval(goNext, 4500);
  };
  const stop = () => {
    clearInterval(timer);
    timer = null;
  };
  function pauseThenResume() {
    stop();
    clearTimeout(resume);
    resume = setTimeout(start, 7000);
  }

  prev.addEventListener("click", () => {
    track.scrollBy({ left: -step(), behavior: "smooth" });
    pauseThenResume();
  });
  next.addEventListener("click", () => {
    goNext();
    pauseThenResume();
  });

  track.addEventListener("touchstart", pauseThenResume, { passive: true });
  wrap.addEventListener("mouseenter", stop);
  wrap.addEventListener("mouseleave", pauseThenResume);
  track.addEventListener("focusin", stop);
  track.addEventListener("focusout", pauseThenResume);

  // Mouse drag to scroll (touch swipe is native)
  let dragging = false;
  let startX = 0;
  let startScroll = 0;
  let moved = false;
  track.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "mouse") return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = track.scrollLeft;
    pauseThenResume();
  });
  track.addEventListener("pointermove", (event) => {
    if (!dragging) return;
    const dx = event.clientX - startX;
    if (Math.abs(dx) > 4) {
      moved = true;
      track.scrollLeft = startScroll - dx;
    }
  });
  ["pointerup", "pointercancel", "pointerleave"].forEach((eventName) =>
    track.addEventListener(eventName, () => (dragging = false))
  );
  track.addEventListener(
    "click",
    (event) => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    },
    true
  );

  start();
});

document.querySelectorAll("[data-global-search-open]").forEach((trigger) => {
  const overlay = document.querySelector("[data-global-search]");
  if (!overlay) return;
  const form = overlay.querySelector("[data-global-search-form]");
  const input = overlay.querySelector("[data-global-search-input]");
  const suggest = overlay.querySelector("[data-global-search-suggest]");
  const productWrap = overlay.querySelector("[data-global-search-products]");
  const linksWrap = overlay.querySelector("[data-global-search-links]");
  const allLink = overlay.querySelector("[data-global-search-all]");
  const hints = overlay.querySelector("[data-global-search-hints]");
  let request;
  let timer;

  const money = (value) => {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? `$${number.toFixed(2)}` : "";
  };

  const openSearch = (event) => {
    event.preventDefault();
    overlay.hidden = false;
    document.body.classList.add("global-search-open");
    requestAnimationFrame(() => overlay.classList.add("is-open"));
    window.setTimeout(() => input?.focus(), 120);
  };

  const closeSearch = () => {
    overlay.classList.remove("is-open");
    document.body.classList.remove("global-search-open");
    request?.abort();
    window.setTimeout(() => { overlay.hidden = true; }, 220);
    trigger.focus();
  };

  trigger.addEventListener("click", openSearch);
  overlay.querySelectorAll("[data-global-search-close]").forEach((closer) => closer.addEventListener("click", closeSearch));
  document.addEventListener("keydown", (event) => { if (event.key === "Escape" && !overlay.hidden) closeSearch(); });

  hints?.querySelectorAll("[data-global-search-hint]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!input || !form) return;
      input.value = button.dataset.globalSearchHint || "";
      form.requestSubmit();
    });
  });

  const clearSuggestions = () => {
    if (productWrap) productWrap.innerHTML = "";
    if (linksWrap) linksWrap.innerHTML = "";
    if (suggest) suggest.hidden = true;
  };

  const renderSuggestions = (results, query) => {
    const products = results?.products || [];
    const collections = results?.collections || [];
    const pages = results?.pages || [];
    if (productWrap) {
      productWrap.innerHTML = "";
      products.slice(0, 8).forEach((product) => {
        const card = document.createElement("a");
        card.className = "global-search-card";
        card.href = product.url;
        const image = product.image || product.featured_image?.url || "";
        card.innerHTML = `${image ? `<img src="${image}" alt="" loading="lazy">` : `<span class="global-search-card-thumb"></span>`}<span class="global-search-card-copy"><strong>${product.title}</strong><small>${product.type || "Product"}${product.price ? ` · ${money(product.price)}` : ""}</small></span>`;
        productWrap.append(card);
      });
    }
    if (linksWrap) {
      linksWrap.innerHTML = "";
      [...collections, ...pages].slice(0, 4).forEach((item) => {
        const link = document.createElement("a");
        link.className = "global-search-link";
        link.href = item.url;
        link.innerHTML = `<span>${item.title}</span><small>${item.type || (collections.includes(item) ? "Collection" : "Page")}</small>`;
        linksWrap.append(link);
      });
    }
    if (allLink) {
      allLink.href = `/search?q=${encodeURIComponent(query)}&type=product,page`;
      allLink.textContent = `See all results for “${query}”`;
    }
    if (suggest) suggest.hidden = !(products.length || collections.length || pages.length);
  };

  input?.addEventListener("input", () => {
    const query = input.value.trim();
    window.clearTimeout(timer);
    if (query.length < 2) { clearSuggestions(); return; }
    timer = window.setTimeout(async () => {
      request?.abort();
      request = new AbortController();
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=10`, { signal: request.signal });
        if (!response.ok) return;
        const json = await response.json();
        renderSuggestions(json.resources?.results || {}, query);
      } catch (error) {
        if (error.name !== "AbortError") clearSuggestions();
      }
    }, 200);
  });
});
